export interface Reference {
    cemexReference: string;
    documentId: number;
    checked?: boolean;
}

export interface SearchReferenceDTO {
    references: Array<Reference>;
    //
    documentTypeCode?: string;
    customerBlobReqId?: number;
}

export interface FileReference {
    uploadTrigger?: boolean;
    uploadDuration?: number;
    checked?: boolean;
    //
    blobDocumentID?: number;
    cemexReference?: string;
    cemexReferenceType?: string;
    customerBlobReqId?: number;
    customerDocsBlobId?: number;
    customerReference?: string;
    documentTypeCode?: string;
    referenceDate?: string;
    referenceDateObj?: Date;
    referenceStatus?: boolean;
    fileName?: string;
    fileContent?: string;
    customerCode: string;
    countryCode: string;
}

export interface File {
    blobDocumentId: number;
    fileName?: string;
    fileContent?: string;
    documentTypeCode?: string;
    documentTypeDesc?: string;
    ticketCode?: string;
}

export interface DocumentFile {
    checked?: boolean;
    uploadDate: string;
    uploadDateObj?: Date;
    documentTypeCode: string;
    documentTypeDesc: string;
    customerDocsBlobId: number;
    cemexReference: string;
    blobDocumentID: number;
    customerReference: string;
    customerDocsStatus: boolean;
    documentSearchCode: string;
    documentSearchDesc: string;
}

export interface DocumentFileDTO {
    documents: Array<DocumentFile>;
}
